import React, { ReactElement } from 'react';
import { useParams } from 'react-router';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { Button, LoaderButton } from 'idsk-react-components';
import { ObalMaterialuNrSrBezchybnostFormData } from '../../../model/pracovnyKrok/ObalMaterialuNrSrBezchybnostFormData';
import { ClientResponse } from '../../../model/ClientResponse';
import { ClientStatus } from '../../../model/ClientStatus';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';

interface Props {
  setObalMaterialu: (obalData: ObalMaterialuNrSrBezchybnostFormData) => void;
  fillSystemDataClient(...args): Promise<ClientResponse<ObalMaterialuNrSrBezchybnostFormData>>;
  fillSystemData: ObalMaterialuNrSrBezchybnostFormData;
  fillSystemDataStatus: ClientStatus;
}

const ObalMaterialuNrSrZaBezchybnostFillSystemDataButton = ({
  setObalMaterialu,
  fillSystemDataStatus,
  fillSystemDataClient,
  fillSystemData,
}: Props): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  const {
    clearMessages,
    displaySuccess,
  } = useSuccessMessageContext();

  const onFillDataClick = async (): Promise<void> => {
    await fillSystemDataClient(type, year, index);
    setObalMaterialu(fillSystemData);
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  return (
    <ConfirmModal
      question="Naozaj si prajete automaticky vyplniť formulár?"
      description="Po vykonaní tejto funkcionality budú prepísané všetky údaje v tomto formulári."
      cancelButtonText="Nie"
      confirmButton={
        (
          <Button
            buttonStyle="action"
            size="large"
          >
            Áno
          </Button>
        )
      }
      openButton={(
        <LoaderButton
          className="fill-obal-data-vseobecny-button"
          buttonStyle="third"
          size="large"
          onClick={clearMessages}
          loading={fillSystemDataStatus.loading}
          disableOutsideClickWhileLoading
        >
          Vyplniť údajmi zo systému
        </LoaderButton>
      )}
      doAfterConfirm={onFillDataClick}
    />
  );
};

export default ObalMaterialuNrSrZaBezchybnostFillSystemDataButton;
